var _rect, _rect2, _circle, _circle2, _circle3, _path, _path2, _path3, _circle4, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path0, _path1, _g4, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskProtectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.472656,
    y: 0.523438,
    width: 80,
    height: 80,
    rx: 22,
    fill: "#2F736E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4695_60364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 81
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.472656,
    y: 0.523438,
    width: 80,
    height: 80,
    rx: 24,
    fill: "#2F736E"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4695_60364)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4725,
    cy: 40.524,
    r: 31.7569,
    stroke: "#7FBCAD",
    strokeOpacity: 0.2,
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4727,
    cy: 40.5237,
    r: 41.1686,
    stroke: "#7FBCAD",
    strokeOpacity: 0.12,
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4726,
    cy: 40.5236,
    r: 52.149,
    stroke: "#7FBCAD",
    strokeOpacity: 0.08,
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6674 50.1487C63.1644 46.9933 64.002 43.4642 64.002 39.7395C64.002 26.3114 53.1163 15.4258 39.6882 15.4258C26.2601 15.4258 15.3745 26.3114 15.3745 39.7395C15.3745 53.1676 26.2601 64.0532 39.6882 64.0532C43.413 64.0532 46.942 63.2157 50.0975 61.7186C48.982 60.3135 48.3157 58.5357 48.3157 56.6023C48.3157 52.054 52.0028 48.367 56.551 48.367C58.4844 48.367 60.2623 49.0332 61.6674 50.1487Z",
    fill: "#589995"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3486 33.3787V37.184L33.9169 49.9663L30.3931 47.3268C29.5221 46.6702 28.812 45.2634 28.812 44.1781V33.3787C28.812 31.8781 29.9643 30.2166 31.3712 29.6941L38.7002 26.9474C39.464 26.666 40.6967 26.666 41.4604 26.9474L48.7895 29.6941C50.1963 30.2166 51.3486 31.8781 51.3486 33.3787Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.3487 39.0195V44.178C51.3487 45.2633 50.6385 46.6702 49.7676 47.3267L42.4385 52.8068C41.7954 53.2891 40.9379 53.5303 40.0804 53.5303C39.2229 53.5303 38.3653 53.2891 37.7222 52.8068L35.1497 50.8908L51.3487 39.0195Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5511,
    cy: 56.6014,
    r: 7.45098,
    fill: "#589995"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4695_60364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7394 52.2891L55.6221 52.5543V56.4243L57.1062 55.9542C57.4825 55.8351 57.7394 55.4761 57.7394 55.0694V52.2891Z",
    fill: "url(#paint0_linear_4695_60364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.539 52.8119C53.117 52.8637 52.7991 53.2335 52.7991 53.6727V58.5218L54.344 58.0522C54.7252 57.9364 54.9869 57.5749 54.9869 57.1644V52.6343L53.539 52.8119Z",
    fill: "url(#paint1_linear_4695_60364)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4695_60364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 52,
    width: 6,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.74 52.2891L55.6227 52.5543V56.4243C56.8833 56.025 57.74 54.8551 57.74 53.5328V52.2891ZM54.9874 52.6343C53.7382 52.7875 52.7996 53.8484 52.7996 55.1069V58.5217C54.0991 58.1268 54.9874 56.9284 54.9874 55.5702V52.6343Z",
    fill: "url(#paint2_linear_4695_60364)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.74 52.2891L55.6227 52.5543V56.4243C56.8833 56.025 57.74 54.8551 57.74 53.5328V52.2891ZM54.9874 52.6343C53.7382 52.7875 52.7996 53.8484 52.7996 55.1069V58.5217C54.0991 58.1268 54.9874 56.9284 54.9874 55.5702V52.6343Z",
    fill: "url(#paint3_linear_4695_60364)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4695_60364)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4695_60364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6744 56.6606L56.7204 58.2123V56.949L56.3277 56.5154L56.1346 54.3103L56.4623 52.2891H55.6744V52.9488L54.6829 54.3103L55.6744 56.6606Z",
    fill: "#75727C",
    fillOpacity: 0.74
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4695_60364)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.2943,
    cy: 57.2726,
    rx: 0.842169,
    ry: 0.870235,
    fill: "#8F8D93",
    fillOpacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4695_60364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7993 58.5546C52.7993 58.3933 52.9264 58.2609 53.0877 58.2562C53.5558 58.2428 54.4958 58.2242 55.1628 58.2657C56.1447 58.3269 57.6622 58.5886 57.6622 58.5886V58.8553H53.0999C52.9339 58.8553 52.7993 58.7207 52.7993 58.5546Z",
    fill: "#1A1821",
    fillOpacity: 0.3
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9243 60.9163L58.0416 60.6511V56.7811L56.5575 57.2511C56.1812 57.3703 55.9243 57.7293 55.9243 58.136V60.9163Z",
    fill: "url(#paint4_linear_4695_60364)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9243 60.9163L58.0416 60.6511V56.7811L56.5575 57.2511C56.1812 57.3703 55.9243 57.7293 55.9243 58.136V60.9163Z",
    fill: "#3A7571",
    fillOpacity: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1247 60.3934C60.5468 60.3417 60.8646 59.9719 60.8646 59.5327V54.6836L59.3197 55.1531C58.9385 55.269 58.6768 55.6304 58.6768 56.041V60.5711L60.1247 60.3934Z",
    fill: "url(#paint5_linear_4695_60364)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1247 60.3934C60.5468 60.3417 60.8646 59.9719 60.8646 59.5327V54.6836L59.3197 55.1531C58.9385 55.269 58.6768 55.6304 58.6768 56.041V60.5711L60.1247 60.3934Z",
    fill: "#3A7571",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_4695_60364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7394 52.2891L55.6221 52.5543V56.4243L57.1062 55.9542C57.4825 55.8351 57.7394 55.4761 57.7394 55.0694V52.2891Z",
    fill: "url(#paint6_linear_4695_60364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.539 52.8119C53.117 52.8637 52.7991 53.2335 52.7991 53.6727V58.5218L54.344 58.0522C54.7252 57.9364 54.9869 57.5749 54.9869 57.1644V52.6343L53.539 52.8119Z",
    fill: "url(#paint7_linear_4695_60364)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4695_60364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 52,
    width: 6,
    height: 7
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.74 52.2891L55.6227 52.5543V56.4243C56.8833 56.025 57.74 54.8551 57.74 53.5328V52.2891ZM54.9874 52.6343C53.7382 52.7875 52.7996 53.8484 52.7996 55.1069V58.5217C54.0991 58.1268 54.9874 56.9284 54.9874 55.5702V52.6343Z",
    fill: "url(#paint8_linear_4695_60364)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.74 52.2891L55.6227 52.5543V56.4243C56.8833 56.025 57.74 54.8551 57.74 53.5328V52.2891ZM54.9874 52.6343C53.7382 52.7875 52.7996 53.8484 52.7996 55.1069V58.5217C54.0991 58.1268 54.9874 56.9284 54.9874 55.5702V52.6343Z",
    fill: "url(#paint9_linear_4695_60364)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4695_60364)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4695_60364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6744 56.6606L56.7204 58.2123V56.949L56.3277 56.5154L56.1346 54.3103L56.4623 52.2891H55.6744V52.9488L54.6829 54.3103L55.6744 56.6606Z",
    fill: "#75727C",
    fillOpacity: 0.74
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_4695_60364)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.2943,
    cy: 57.2726,
    rx: 0.842169,
    ry: 0.870235,
    fill: "#8F8D93",
    fillOpacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_4695_60364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7993 58.5546C52.7993 58.3933 52.9264 58.2609 53.0877 58.2562C53.5558 58.2428 54.4958 58.2242 55.1628 58.2657C56.1447 58.3269 57.6622 58.5886 57.6622 58.5886V58.8553H53.0999C52.9339 58.8553 52.7993 58.7207 52.7993 58.5546Z",
    fill: "#1A1821",
    fillOpacity: 0.3
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9243 60.9163L58.0416 60.6511V56.7811L56.5575 57.2511C56.1812 57.3703 55.9243 57.7293 55.9243 58.136V60.9163Z",
    fill: "url(#paint10_linear_4695_60364)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9243 60.9163L58.0416 60.6511V56.7811L56.5575 57.2511C56.1812 57.3703 55.9243 57.7293 55.9243 58.136V60.9163Z",
    fill: "#3A7571",
    fillOpacity: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1247 60.3934C60.5468 60.3417 60.8646 59.9719 60.8646 59.5327V54.6836L59.3197 55.1531C58.9385 55.269 58.6768 55.6304 58.6768 56.041V60.5711L60.1247 60.3934Z",
    fill: "url(#paint11_linear_4695_60364)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1247 60.3934C60.5468 60.3417 60.8646 59.9719 60.8646 59.5327V54.6836L59.3197 55.1531C58.9385 55.269 58.6768 55.6304 58.6768 56.041V60.5711L60.1247 60.3934Z",
    fill: "#3A7571",
    fillOpacity: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4695_60364",
    x: 52.7991,
    y: 52.2891,
    width: 4.94043,
    height: 8.79194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.43898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4695_60364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4695_60364",
    x: 29.9257,
    y: 27.5319,
    width: 51.552,
    height: 55.4382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3786,
    result: "effect1_foregroundBlur_4695_60364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4695_60364",
    x: 28.695,
    y: 31.6452,
    width: 51.1987,
    height: 51.2546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3786,
    result: "effect1_foregroundBlur_4695_60364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4695_60364",
    x: 32.6965,
    y: 38.1374,
    width: 45.0685,
    height: 40.8209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0514,
    result: "effect1_foregroundBlur_4695_60364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_4695_60364",
    x: 52.7991,
    y: 52.2891,
    width: 4.94043,
    height: 8.79194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.55952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.43898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4695_60364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4695_60364",
    x: 29.9257,
    y: 27.5319,
    width: 51.552,
    height: 55.4382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3786,
    result: "effect1_foregroundBlur_4695_60364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_4695_60364",
    x: 28.695,
    y: 31.6452,
    width: 51.1987,
    height: 51.2546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3786,
    result: "effect1_foregroundBlur_4695_60364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_4695_60364",
    x: 32.6965,
    y: 38.1374,
    width: 45.0685,
    height: 40.8209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0514,
    result: "effect1_foregroundBlur_4695_60364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4695_60364",
    x1: 55.2698,
    y1: 59.152,
    x2: 61.37,
    y2: 52.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4695_60364",
    x1: 55.2698,
    y1: 59.152,
    x2: 61.37,
    y2: 52.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4695_60364",
    x1: 57.7207,
    y1: 51.0756,
    x2: 54.3441,
    y2: 62.1757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26DE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451208,
    stopColor: "#15BD81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0994A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4695_60364",
    x1: 54.713,
    y1: 58.8915,
    x2: 61.0611,
    y2: 52.4535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4695_60364",
    x1: 58.3464,
    y1: 53.3591,
    x2: 51.0113,
    y2: 63.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4695_60364",
    x1: 58.3464,
    y1: 53.3591,
    x2: 51.0113,
    y2: 63.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4695_60364",
    x1: 55.2698,
    y1: 59.152,
    x2: 61.37,
    y2: 52.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4695_60364",
    x1: 55.2698,
    y1: 59.152,
    x2: 61.37,
    y2: 52.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4695_60364",
    x1: 57.7207,
    y1: 51.0756,
    x2: 54.3441,
    y2: 62.1757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26DE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451208,
    stopColor: "#15BD81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0994A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4695_60364",
    x1: 54.713,
    y1: 58.8915,
    x2: 61.0611,
    y2: 52.4535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4695_60364",
    x1: 58.3464,
    y1: 53.3591,
    x2: 51.0113,
    y2: 63.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4695_60364",
    x1: 58.3464,
    y1: 53.3591,
    x2: 51.0113,
    y2: 63.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9694A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskProtectionIcon);
export default __webpack_public_path__ + "static/media/risk-protection-icon.cd8ee869590b334419550aa76c6b2e63.svg";
export { ForwardRef as ReactComponent };